import { render, staticRenderFns } from "./index.vue?vue&type=template&id=18ed47d5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=18ed47d5&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ed47d5')) {
      api.createRecord('18ed47d5', component.options)
    } else {
      api.reload('18ed47d5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=18ed47d5", function () {
      api.rerender('18ed47d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/syslogs/index.vue"
export default component.exports